module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-toolbar",
    attrs: {
      "role": "toolbar"
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.session
    },
    on: {
      "click": function($event) {
        _vm.setupAndRun()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" Compile & Run")], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setup()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" Setup")], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || _vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "undo"
    }
  }), _vm._v(" Reset")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || _vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.run()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "play-circle"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pause-circle"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isPaused()
    },
    on: {
      "click": function($event) {
        _vm.step()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "step-forward"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isPaused()
    },
    on: {
      "click": function($event) {
        _vm.tick()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "fast-forward"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "width": "256px"
    }
  }, [_c('vue-slider', {
    attrs: {
      "data": _vm.speedData,
      "piecewise": true,
      "piecewiseLabel": true,
      "tooltip": "hover",
      "disabled": !_vm.session
    },
    on: {
      "callback": _vm.setSpeed
    },
    model: {
      value: (_vm.speedValue),
      callback: function($$v) {
        _vm.speedValue = $$v
      },
      expression: "speedValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('checkbox', {
    attrs: {
      "disabled": !_vm.session.scheduler,
      "button": true
    },
    model: {
      value: (_vm.session.showScheduler),
      callback: function($$v) {
        _vm.session.showScheduler = $$v
      },
      expression: "session.showScheduler"
    }
  }, [_c('icon', {
    attrs: {
      "name": "tasks",
      "title": _vm.session.scheduler ? _vm.session.scheduler.type.name : 'Scheduler not initialized'
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-status",
    class: _vm.statusClass
  }, [(_vm.session.scheduler) ? _c('span', [_c('icon', {
    attrs: {
      "name": _vm.session.scheduler.state.icon
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.state.name) + "\n                "), (_vm.session.scheduler.isPaused()) ? _c('span', [_vm._v(" ["), _c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.nextExecutor.agent.name) + "]")], 1) : _vm._e(), _vm._v(" "), (_vm.session.scheduler.isError()) ? _c('span', [_vm._v(" ["), _c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.nextExecutor.agent.name) + "] " + _vm._s(_vm.session.scheduler.exception.message))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.session.scheduler) ? _c('span', [_vm._v("Please compile your code to run the simulation...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.session.scheduler && _vm.session.showScheduler) ? _c('schedulerPanel', {
    attrs: {
      "scheduler": _vm.session.scheduler
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "simulator-canvas",
    attrs: {
      "id": "parapple-canvas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70a1e09a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/simulator/Simulator.vue
// module id = 1543
// module chunks = 2